import {
  ArchiveTitleRuleItemDisplayType,
  ArchiveTitleRuleItemType,
} from './archive-title-rule-item-type.enum';
import { ArchiveTitleRuleItemParamInfo } from './archive-title-rule-item-param-info.model';
export class ArchiveTitleRuleItemInfo {
  type?: ArchiveTitleRuleItemType;
  formHeaderName?: string;
  params?: Array<ArchiveTitleRuleItemParamInfo>;
  // 前端自用
  displayType?: ArchiveTitleRuleItemDisplayType;
}
